import { FederatedPointerEvent, IDestroyOptions, Sprite, TextStyle } from "pixi.js";
import { MyWalletResourcePackage } from "../../resources/MyWalletResourcePackage";
import { ButtonWithScaleAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/ButtonWithScaleAnimation";
import { TextWithUnderline } from "by/gamefactory/cityversetycoon/scenes/game/components/TextWithUnderline";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { Event } from "event-system";

export class MyWalletSwitchNetworkTooltip extends Sprite {
    public readonly onTextClick: Event<void>;

    private static readonly SWITCH_NETWORK_TEXT = 'PLEASE SWITCH TO BASE NETWORK';

    private readonly closeButton: ButtonWithScaleAnimation;
    private readonly switchNetworkText: TextWithUnderline;

    public get onCloseButtonClick(): Event<ButtonWithScaleAnimation, FederatedPointerEvent> {
        return this.closeButton.onUp;
    }

    public constructor(myWalletResources: MyWalletResourcePackage, commonResources: CommonResourcesPackage) {
        super(myWalletResources.assets_views_my_wallet_ui_network_tooltip_png);
        this.closeButton = new ButtonWithScaleAnimation(commonResources.assets_common_x_png);
        this.closeButton.defaultView.width = this.closeButton.defaultView.height = 33;
        this.closeButton.position.set(this.width - this.closeButton.width - 30, 20);
        this.switchNetworkText = new TextWithUnderline(MyWalletSwitchNetworkTooltip.SWITCH_NETWORK_TEXT, new SwitchNetworkTextStyle(), 0, -4, 3);
        this.switchNetworkText.eventMode = "static";
        this.switchNetworkText.position.set(37, 21);
        this.addChild(this.closeButton, this.switchNetworkText);
        this.switchNetworkText.on("pointerup", this.onSwitchNetworkTextClickHandle, this);
        this.onTextClick = new Event();
    }

    private onSwitchNetworkTextClickHandle(): void {
        this.onTextClick.emit();
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.switchNetworkText.off("pointerup", this.onSwitchNetworkTextClickHandle, this);
        super.destroy(options);
    }
}

class SwitchNetworkTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 32,
            fill: 'FFFFFF'
        });
    }
}